import { render, staticRenderFns } from "./invitation-apply.vue?vue&type=template&id=b6237c3a"
import script from "./invitation-apply.vue?vue&type=script&lang=js"
export * from "./invitation-apply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports